import type { ComponentProps } from "react"
import { Input } from "@/components/ui/primitives"
import { sectorsDraftFromRaw } from "@/lib/location-scene-3d/platform-size-draft"

type PlatformSectorCountInputProps = Omit<
  ComponentProps<typeof Input>,
  "value" | "onChange" | "type" | "inputMode" | "autoComplete" | "onBlur"
> & {
  value: string
  onValueChange: (draft: string) => void
  onCommit: () => void
}

/** Sector count as text: digits only, commit (clamp) on blur. Same field as scene create. */
export function PlatformSectorCountInput({
  value,
  onValueChange,
  onCommit,
  onFocus,
  ...props
}: PlatformSectorCountInputProps) {
  return (
    <Input
      {...props}
      type="text"
      inputMode="numeric"
      autoComplete="off"
      value={value}
      onFocus={onFocus}
      onChange={(event) => onValueChange(sectorsDraftFromRaw(event.target.value))}
      onBlur={onCommit}
    />
  )
}
